import React, { useContext, useMemo, useState } from "react";
import "components/client/dashboard/profile/Cards/cards.css";
import "components/auth/common/common.css";
import "components/rep/accounts/account.css";
import "components/rep/settings/subscriptions/cancel/cancel.css";
import "./setting.css";
import { getUserReferralLink, makeToast } from "helpers/common";
import LoginInput from "components/auth/common/LoginInput";
import SectionTitle from "components/auth/onboarding/SectionTitle";
import { UserContext } from "components/context/UserContext";
import { createOfficeInvite } from "services/profileServices";

interface RepReferralsProps {}
interface iReferralFormData {
  officeName?: string;
  officeEmail?: string;
}
const RepReferrals: React.FC<RepReferralsProps> = () => {
  const { state } = useContext(UserContext)!;

  const [referralFormData, setReferralFormData] = useState<iReferralFormData>(
    {}
  );
  const [loading, setLoading] = useState<boolean>(false);
  const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  const isValidName = (name: string) => name && name.length >= 3;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(myReferralLink).then(() => {
      makeToast("Referral link copied to clipboard!", "success");
    });
  };
  const handleChange = (prop: string) => (value: string) => {
    setReferralFormData((prev: iReferralFormData) => ({
      ...prev,
      [prop]: value,
    }));
  };
  const handleSubmit = async () => {
    const { officeName, officeEmail } = referralFormData;
    if (!isValidEmail(officeEmail || "") || !isValidName(officeName || "")) {
      makeToast(
        "Please provide a valid email and office name (at least 3 characters).",
        "error"
      );
      return;
    }
    try {
      setReferralFormData({});
      setLoading(true);
      const response = await createOfficeInvite({
        officeName,
        officeEmail,
      });
      makeToast(response?.message, response.isSuccessful ? "success" : "error");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      makeToast("An error occurred while creating the referral", "error");
    }
  };

  const myReferralLink = useMemo(() => {
    if (state.currentUser.id) return getUserReferralLink(state.currentUser.id);
    return "No User Data Found";
  }, [state]);
  return (
    <div className="rep-referrals-container">
      <div style={{ maxHeight: 35 }}>
        <SectionTitle
          label="Your Referral Link"
          overrideLabelClass={"od-bold-label"}
        />
      </div>
      <div className="r-link-container">
        <input
          type="text"
          value={myReferralLink}
          placeholder="Your Referral Link"
          readOnly
          className="r-link-input"
        />
        <button className="r-link-btn" onClick={copyToClipboard}>
          Copy
        </button>
      </div>
      <div style={{ maxHeight: 35 }}>
        <SectionTitle
          label="Earn Rewards by Referring Others!"
          overrideLabelClass={"od-bold-label"}
        />
      </div>
      <div className="r-form-container">
        <span className="r-subtitle" style={{ color: "#4A4A4A" }}>
          Know an office that could benefit from MyRep? Register your referral
          to ensure you get rewarded when they sign up! While sharing your
          unique referral link is the easiest way to track referrals, we
          understand that not every office will use it. That’s why registering
          their name and email here still secures your opportunity to earn
          rewards. The first successful sign-up earns you full reward credit,
          while the next four receive partial credit. Don’t miss out—start
          referring today!
        </span>
        <LoginInput
          label="Office name"
          value={referralFormData.officeName}
          name={"officeName"}
          onChange={handleChange}
          type="text"
          placeholder={"Office name"}
          customInputFieldStyle={{ color: "#3F77CD" }}
        />
        <LoginInput
          label="Office Email"
          value={referralFormData.officeEmail}
          name={"officeEmail"}
          onChange={handleChange}
          type="text"
          placeholder={"Office Email"}
          customInputFieldStyle={{ color: "#3F77CD" }}
        />
        <button
          className="cancel-un-follow-btn"
          style={{ borderRadius: 4 }}
          onClick={handleSubmit}
          disabled={
            !referralFormData.officeName ||
            !referralFormData.officeEmail ||
            loading
          }
        >
          {loading ? "Submitting..." : "Submit Referral"}
        </button>
      </div>
    </div>
  );
};

export default RepReferrals;
